/**
 * Identidade visual das áreas do comitê — espelho presentacional de
 * `constants/especialistas.py` do backend.
 *
 * Os ids SÃO os do backend: chegam em `turno.area`, `mesa[].area` e no evento
 * `painel_evento{tipo:'status'}`. Um id divergente aqui não quebra a tela — cai
 * no fallback do orquestrador —, e é justamente esse silêncio que o teste de
 * drift ao lado impede.
 *
 * Só o ÍCONE mora aqui. O nome de negócio (`label`) vem do backend em cada turno
 * e em cada linha da mesa: duplicá-lo criaria duas versões que divergem no
 * primeiro renome.
 *
 * Não há cor por área — decisão de design registrada em `components-reused.md`
 * (regra 3): no painel a cor carrega significado (classe da contribuição,
 * posição da réplica). Identidade de área é ícone + nome em texto, o que também
 * atende WCAG AA (nada é transmitido só por cor).
 */

export const AREA_ESTRATEGIA_MA = 'estrategia_ma'
export const AREA_JURIDICO_REGULATORIO = 'juridico_regulatorio'
export const AREA_FINANCEIRO_CONTABIL_TRIBUTARIO = 'financeiro_contabil_tributario'
export const AREA_TECNOLOGIA_OPERACAO = 'tecnologia_operacao'
export const AREA_COMERCIAL_CAPTACAO = 'comercial_captacao'
export const AREA_MARCA_AQUISICAO = 'marca_aquisicao'
export const AREA_PESSOAS_CARREIRA_PARTNERSHIP = 'pessoas_carreira_partnership'

// Ícone do Consultor que conduz a conversa — e fallback de qualquer área que o
// backend passe a registrar antes deste mapa saber dela.
export const ICONE_ORQUESTRADOR = 'ia-head'

export const AREA_IDENTIDADE = {
  [AREA_ESTRATEGIA_MA]: { icone: 'analyze-market' },
  [AREA_JURIDICO_REGULATORIO]: { icone: 'shield-user' },
  [AREA_FINANCEIRO_CONTABIL_TRIBUTARIO]: { icone: 'chart-finance' },
  [AREA_TECNOLOGIA_OPERACAO]: { icone: 'monitor' },
  [AREA_COMERCIAL_CAPTACAO]: { icone: 'trend-up' },
  [AREA_MARCA_AQUISICAO]: { icone: 'brush' },
  [AREA_PESSOAS_CARREIRA_PARTNERSHIP]: { icone: 'peoples' },
}

// Os sete ids que o backend registra hoje. Lista literal (não `Object.keys`)
// para que acrescentar uma área ao mapa seja uma decisão consciente, conferida
// contra `constants/especialistas.py`.
export const AREAS_BACKEND_IDS = [
  AREA_JURIDICO_REGULATORIO,
  AREA_TECNOLOGIA_OPERACAO,
  AREA_ESTRATEGIA_MA,
  AREA_FINANCEIRO_CONTABIL_TRIBUTARIO,
  AREA_COMERCIAL_CAPTACAO,
  AREA_MARCA_AQUISICAO,
  AREA_PESSOAS_CARREIRA_PARTNERSHIP,
]

/**
 * O `name` de `icon-svg` para uma área, com fallback no ícone do orquestrador.
 *
 * O guard `Object.hasOwn` é obrigatório: o mapa é objeto literal e herda de
 * `Object.prototype`, então `AREA_IDENTIDADE['toString']` devolveria uma função
 * e `.icone` viraria `undefined` — o `icon-svg` renderizaria vazio, em silêncio.
 *
 * @param {String} area Id da área, como o backend a nomeia.
 * @returns {String} Nome de um SVG existente em `src/components/icons/svg/`.
 */
export function iconeDaArea(area) {
  if (area && Object.hasOwn(AREA_IDENTIDADE, area)) return AREA_IDENTIDADE[area].icone
  return ICONE_ORQUESTRADOR
}
